const pathConstants = {
  PRO_RESOURCE_PREFIX: '/m/ws/',
  PRO_RESOURCE_PREFIX_WD: '/m/wd/',
  PRO_RESOURCE_PREFIX_UNION: '/m/union/'
}

export default pathConstants
